import { Getter } from "./ComService"

interface IItem {
  initials: string,
  color: string,
  name: string,
  id: number,
}

class UserNameService {
  items = new Map<number, IItem>()
  fallbackItem = {
    initials: '-',
    name: 'Keiner Ausgewählt',
    color: '#000',
    id: -1
  }
  async get (id?: number): Promise<IItem> {
    if (id === undefined || id < 0) {
      return this.fallbackItem
    }
    if (this.items.has(id)) {
      return this.items.get(id) || this.fallbackItem
    }
    try {
      const data = await Getter(`user/${id}`)
      console.log('### person data name', data)
      const item = {
        initials: data.initials,
        name: data.name,
        color: data.color,
        id: id
      }
      this.items.set(id, item)
      return item
    } catch (e) {
      return this.fallbackItem
    }
  }
  async getInitials (id?: number) {
    const item = await this.get(id)
    const name = item.name.split(/ @/)
    if (name.length > 1) {
      return name[0][0] + ' ' + name[1][0]
    }
    return item.name
  }
  async getName (id?: number) {
    const item = await this.get(id)
    return item.name
  }
}
const userNameService = new UserNameService()
export default userNameService
